import { HasProductContext, ProductContextModel, withProductContext } from "@insite/client-framework/Components/ProductContext";
import Zone from "@insite/client-framework/Components/Zone";
import { getProductById } from "@insite/client-framework/Services/ProductServiceV2";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductState, getProductStateByPath } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import {Collapsable} from "@ucs/Components/Collapsable";
import * as React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";


const ProductDownloadsContainer = styled.div`
    background-color: white;
    padding: 22px calc(10% - 15px) calc(10%);
    height: 100%;
    background-color: white;
    h2 {
        margin-left: 15px;
        margin-right: 15px;
    }
    button {
        margin-left: 15px;
        margin-right: 15px;
        width: calc(100% - 37px);
        border: 1px solid ${getColor("primary")};
        background-color: white;
        color: black;
        &:hover {
            color: white;
        }
    }

    ${({ theme }) => {
        return breakpointMediaQueries(theme, [
            css`
                padding: 28px 0;
            `,
            css`
                padding: 28px 0;
            `,
        ]);
    }}
`;

const ImagesContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    > a {
        width: calc(33% - 30px);
        margin: 15px;
        /* background-color: gray; */
        background-position: center;
        background-size: cover;
        &:before {
            content: "";
            display: block;
            padding-top: 100%;
        }

        
        ${({ theme }) => {
            return breakpointMediaQueries(theme, [
                css`
                    margin: 10px 10px 0 0;
                `,
                css`
                    margin: 10px 10px 0 0;
                `,
            ]);
        }}
    }
`;

type Props =
    ReturnType<typeof mapStateToProps> &
    HasProductContext;

const mapStateToProps = (state: ApplicationState, productContext: ProductContextModel) => { 
    let parentImages;
    if((productContext as any)?.productContext.product.images.length === 0){
        parentImages = getProductStateByPath(state, `/Product/${(productContext as any)?.productContext.product.urlSegment}`).value?.images;
    }
    return({
        state,
        parentImages,
    });
}

const MobileContainer = styled.div`
    display: none;
    ${({ theme }) => 
            (breakpointMediaQueries(theme, 
            [css`display: block;`,
            css`display: block;`,]))};
`;

const Container = styled.div`
    height: 100%;
    ${({ theme }) => 
        (breakpointMediaQueries(theme, 
        [css`display: none;`,
        css`display: none;`,
        ]))};
`;
    

const ProductDownloads: React.FC<Props> = ({
    productContext: { product, productInfo },
    state, 
    parentImages,
}: Props) => {
    const downloads: any[] = [];
    let packageAvailable = false;
    let documentPackage = "";

    if (parentImages) {
        parentImages.forEach((image) => {
            if (image.name.toLowerCase().includes('_dl_')) {
                downloads.push({ name: image.name, medium: image.mediumImagePath, large: image.largeImagePath });
            }
        });
    }else if(product.images){
        product.images.forEach((image) => {
            if (image.name.toLowerCase().includes('_dl_')) {
                downloads.push({ name: image.name, medium: image.mediumImagePath, large: image.largeImagePath });
            }
        });
    }

    downloads.sort((a, b) => {
        return a.name.localeCompare(b.name);
    });

    if (product.documents) {
        product.documents.forEach((document) => {
            if (document.name === `${product.productNumber}.zip`) {
                packageAvailable = true;
                documentPackage = document.filePath;
            }
        });
    }

    return (
        <>
            <MobileContainer>
                <Collapsable title="Downloads">
                    <ProductDownloadsContainer>
                        <ImagesContainer>
                            {downloads.map((download, idx) => (
                                <a key={idx} href={download.large} target="_blank" style={{"backgroundImage": `url("${download.medium}"`}}></a>
                            ))}
                        </ImagesContainer>
                        {packageAvailable && (
                            <Button onClick={() => {
                                if (window) {
                                    window.open(documentPackage, '_blank')!.focus()
                                }
                            }}>
                                Download Package
                            </Button>
                        )}
                    </ProductDownloadsContainer>
                </Collapsable>
            </MobileContainer>
            <Container>
                <ProductDownloadsContainer>
                    <Typography variant="h2" as="h2">
                        Downloads
                    </Typography>
                    <ImagesContainer>
                        {downloads.map((download, idx) => (
                            <a key={idx} href={download.large} target="_blank" style={{"backgroundImage": `url("${download.medium}"`}}></a>
                        ))}
                    </ImagesContainer>
                    {packageAvailable && (
                        <Button onClick={() => {
                            if (window) {
                                window.open(documentPackage, '_blank')!.focus()
                            }
                        }}>
                            Download Package
                        </Button>
                    )}
            </ProductDownloadsContainer>
            </Container>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withProductContext(connect(mapStateToProps)(ProductDownloads)),
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
